// @flow
import type { Plugin } from '@bugsnag/core'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

// Adds uptime infromation to report metadata.
const uptime: (Date | void) => Plugin = (since = new Date()) => ({
  name: '@toggl-uptime',
  load(client) {
    client.addOnError((event) => {
      event.addMetadata('uptime', {
        since,
        // $FlowFixMe[prop-missing]: Missing plugin functions.
        up: dayjs(since).fromNow(true),
      })
    })
  },
})

export default uptime
